var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import "../../styles/scrollbar.css";
import { Provider } from "react-redux";
import store from "../../store";
import { I18nextProvider } from "react-i18next";
import i18Next from "i18next";
import { ClientsPage } from "./clients";
import { AuthProvider } from "../../authContext";
import vimenca_es from "../../translations/locales/es/vimenca.json";
import vimenca_en from "../../translations/locales/en/vimenca.json";
import banesco_es from "../../translations/locales/es/banesco.json";
import banesco_en from "../../translations/locales/en/banesco.json";
import apap_auto_es from "../../translations/locales/es/apap-auto.json";
import apap_auto_en from "../../translations/locales/en/apap-auto.json";
import default_en from "../../translations/locales/en/default.json";
import default_es from "../../translations/locales/es/default.json";
import { coreTheme } from "../../theme/core.theme";
// Initialize i18next if not already initialized
if (!i18Next.isInitialized) {
    i18Next.init({
        interpolation: { escapeValue: false },
        lng: "es",
        ns: ["default", "apapauto", "vimenca", "banesco"],
        defaultNS: "default",
        resources: {
            en: {
                default: default_en,
                apapauto: apap_auto_en,
                vimenca: vimenca_en,
                banesco: banesco_en,
            },
            es: {
                default: default_es,
                apapauto: apap_auto_es,
                vimenca: vimenca_es,
                banesco: banesco_es,
            },
        },
    });
}
var ClientsWithProvider = function () {
    return (_jsx(MantineProvider, __assign({ theme: coreTheme }, { children: _jsx(Provider, __assign({ store: store }, { children: _jsx(AuthProvider, { children: _jsx(I18nextProvider, __assign({ i18n: i18Next }, { children: _jsx(ClientsPage, {}) })) }) })) })));
};
export default ClientsWithProvider;
